import { FC } from 'react';

import { FilterType } from '@/shared/config';
import { Checkbox } from '@/shared/ui';

import styles from './filterList.module.scss';

interface FilterListProps {
  filter: FilterType;
  selectedValues: number[];
  onToggleValue: (attributeId: number, valueId: number) => void;
}

const FilterList: FC<FilterListProps> = (props) => {
  const { filter, selectedValues, onToggleValue } = props;

  return (
    <ul className={styles.list}>
      {filter.values?.map((option) => {
        const isChecked = selectedValues.includes(+option.value);

        return (
          <li key={option.value} className={styles.list__item}>
            <Checkbox
              checked={isChecked}
              label={option.label}
              onChange={() => onToggleValue(filter.attribute_id, +option.value)}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default FilterList;
